<template>
    <el-button
        :class="{
            'no-label': !label,
            [customClass]: true,
            'disabled-transparent': disabled && disableStyle === 'transparent',
            'disabled-greyed': disabled && disableStyle === 'greyed',
            'chart-refresh-btn': icon === 'el-icon-refresh'
        }"
        :size="size"
        @click="handleClick"
        :type="type"
        :loading="loading"
        :icon="icon"
        :disabled="disabled"
        :plain="plain"
        :title="icon === 'el-icon-refresh' ? 'Làm mới' : ''"
    >
        {{ label }}
    </el-button>
</template>

<script>
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import Vue from 'vue'
Vue.use(ElementUI)

export default {
    name: 'CustomButton',
    components: {
        ElButton: ElementUI.Button
    },
    data() {
        return {}
    },
    props: {
        ...ElementUI.Button.props,
        size: {
            type: String,
            default: 'small'
        },
        type: {
            type: String,
            default: 'primary'
        },
        label: {
            type: String
        },
        loading: {
            type: Boolean,
            default: false
        },
        icon: {
            type: String,
            require: true
        },
        disabled: {
            type: Boolean,
            default: false
        },
        disableStyle: {
            type: String,
            default: 'transparent', // 'greyed' hoặc 'transparent'
            validator: (value) => ['greyed', 'transparent'].includes(value)
        },
        plain: {
            type: Boolean,
            default: false
        },
        customClass: {
            type: String,
            default: ''
        }
    },

    methods: {
        handleClick() {
            this.$emit('click', () => {})
        }
    }
}
</script>

<style scoped>
/* Center icon when button has no label */
.el-button.no-label {
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    padding: 12px 15px !important;
}

/* Disable: Greyed out style */
.el-button.disabled-greyed:disabled,
.el-button.disabled-greyed.is-disabled {
    background-color: #d3d3d3 !important;
    border-color: #d3d3d3 !important;
    color: #737576 !important;
    opacity: 1 !important;
    cursor: not-allowed;
}

/* Disable: Transparent style - giữ nguyên màu nhưng làm mờ đi */
.el-button.disabled-transparent:disabled,
.el-button.disabled-transparent.is-disabled {
    opacity: 0.4 !important;
    cursor: not-allowed;
}

/* Button primary disabled với transparent */
.el-button--primary.disabled-transparent:disabled,
.el-button--primary.disabled-transparent.is-disabled {
    background-color: var(--blue-200) !important;
    border-color: var(--blue-200) !important;
    color: #ffffff !important;
    opacity: 0.4 !important;
}

/* Chart refresh button styling */
::v-deep .chart-refresh-btn .el-icon-refresh:before {
    color: #ffffff !important;
}
</style>

<style>
/* Non-scoped styles to properly target Element UI internal structure */
/* Center icon in button with no label */
.el-button.no-label [class*='el-icon-'] {
    margin: 0 !important;
}

/* Hide the empty span that Element UI adds when there's no label */
.el-button.no-label > span {
    display: none !important;
}

/* Make sure the icon itself is visible and centered */
.el-button.no-label > i {
    display: inline-block !important;
    margin: 0 !important;
}

.el-button--text {
    color: #ffffff !important;
}
</style>
